import type { GetUnreadCount, LoadNotifications, MarkAllNotificationsRead, MarkNotificationRead } from '@/domain/use-cases/notifications.js';
import { BaseControllerImpl } from '@/presentation/controllers/base/implementation.js';

export class NotificationController extends BaseControllerImpl {
    constructor(
        private readonly loadNotificationsUseCase: LoadNotifications,
        private readonly markNotificationReadUseCase: MarkNotificationRead,
        private readonly markAllNotificationsReadUseCase: MarkAllNotificationsRead,
        private readonly getUnreadCountUseCase: GetUnreadCount
    ) {
        super();
    }

    public async loadNotifications(params?: { page?: number; limit?: number; filter?: 'all' | 'unread' | 'read' }) {
        return this.loadNotificationsUseCase.execute(params);
    }

    public async markRead(id: string) {
        return this.markNotificationReadUseCase.execute(id);
    }

    public async markAllRead() {
        return this.markAllNotificationsReadUseCase.execute();
    }

    public async getUnreadCount() {
        return this.getUnreadCountUseCase.execute();
    }
}
